/* file: brand/back-to-top.js -> assets/ef-top.js (header, homepage, the 11.11 page and product pages; tools/back_to_top.py)
 *
 * Owner, 04NOV2026: "at landing help add mechanism where you scroll down you can one click back to top".
 * One round button above the WhatsApp bubble. It appears once the visitor is past the first screen and a
 * half, its ring fills with how far down the page they are, and one click takes them to the top (instantly
 * under reduced motion). Focus goes to the page's first heading, so keyboard users land where they look.
 */
(function () {
  "use strict";
  var doc = document, root = doc.documentElement;
  if (doc.querySelector(".ef-top")) return;
  var ms = (root.lang || "").toLowerCase().indexOf("ms") === 0;
  var label = ms ? "Kembali ke atas" : "Back to top";
  var R = 20, LEN = 2 * Math.PI * R;

  var b = doc.createElement("button");
  b.type = "button";
  b.className = "ef-top";
  b.setAttribute("aria-label", label);
  b.title = label;
  b.innerHTML =
    '<svg class="ef-top__ring" viewBox="0 0 48 48" aria-hidden="true">' +
    '<circle cx="24" cy="24" r="' + R + '"></circle>' +
    '<circle class="ef-top__fill" cx="24" cy="24" r="' + R + '" stroke-dasharray="' + LEN + '" stroke-dashoffset="' + LEN + '"></circle></svg>' +
    '<svg class="ef-top__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5.5 11.5 12 5l6.5 6.5"></path></svg>';
  doc.body.appendChild(b);
  var fill = b.querySelector(".ef-top__fill");

  var ticking = false;
  function update() {
    ticking = false;
    var y = window.scrollY || root.scrollTop, max = root.scrollHeight - window.innerHeight;
    b.classList.toggle("is-on", y > window.innerHeight * 1.5);
    fill.setAttribute("stroke-dashoffset", String(LEN * (1 - (max > 0 ? Math.min(1, y / max) : 0))));
  }
  window.addEventListener("scroll", function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener("resize", update);
  update();

  b.addEventListener("click", function () {
    var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    /* the theme sets scroll-behavior: smooth on <html>, so "auto" glides too, and a 17,000px glide took
       seconds: jump to one screen from the top, then glide that last screen ("instant" when motion is off) */
    if (!still && (window.scrollY || root.scrollTop) > window.innerHeight * 2) {
      window.scrollTo({ top: window.innerHeight, behavior: "instant" });
    }
    window.scrollTo({ top: 0, behavior: still ? "instant" : "smooth" });
    var h = doc.querySelector("main h1, main h2, h1");
    if (h) {
      if (!h.hasAttribute("tabindex")) h.setAttribute("tabindex", "-1");
      h.focus({ preventScroll: true });
    }
  });
})();
